import {http} from "Services/Http/HttpClient";
import axios from "axios";
import {getAuth} from "../../Services/Security/AuthService";

export const getConfigList = async() => {
    return http.get('/config')
}

export const getConfig = async(id: string) => {
    return http.get('/config/' + id)
}

export const updateConfig = async(id: string, value: string) => {
    return http.patch('/config/' + id, {
        value: value
    })
}

export const uploadConfigFile = async (file: any, configKey: string) => {
    let data = new FormData()
    data.append('file', file.file)
    data.append('key', configKey)

    const fhttp = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-type": "multipart/form-data;",
            "Authorization": getAuth()
        }
    })

    return fhttp.post(`/config/upload`, data)
}